// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3A712","brand":"header-module--brand--3tjli","nav":"header-module--nav--2TcPd"};